import './page-init.js';
import UpdateIndicator from './update-indicator.js';

customElements.define('snappy-update-indicator', UpdateIndicator);
